/* Box plan picker: updates total, note and CTA when a plan row is clicked */
(function(){
  var productUrl='/products/discover-our-farms-box?view=our-farms-box&plan=';
  var P={annual:{t:'$375',s:'$396 quarterly',v:'Save $21',n:'Billed once a year. Ships Feb, May, Aug & Dec; first Box ships in the first half of December.',c:'Start Annual & Save $21'},
         quarterly:{t:'$99',s:'',v:'',n:'Billed each season. Ships Feb, May, Aug & Dec; first Box ships in the first half of December.',c:'Start Quarterly'},
         gift:{t:'$375',s:'',v:'',n:'One payment. Ships Feb, May, Aug & Dec; first Box ships in the first half of December. No auto-renew.',c:'Give a Year'}};
  var rows=document.querySelectorAll('[data-plan]');
  function pick(k){
    rows.forEach(function(r){var on=r.getAttribute('data-plan')===k;r.setAttribute('aria-pressed',on);r.style.border=on?'2px solid #314424':'1px solid #E3D7C3'});
    var d=P[k];
    document.getElementById('planTotal').textContent=d.t;
    var st=document.getElementById('planStrike');st.textContent=d.s;st.style.display=d.s?'':'none';
    var sv=document.getElementById('planSave');sv.textContent=d.v;sv.style.visibility=d.v?'visible':'hidden';
    document.getElementById('planNote').textContent=d.n;
    var cta=document.getElementById('planCta');
    cta.textContent=d.c;
    cta.href=productUrl+k;
  }
  rows.forEach(function(r){r.addEventListener('click',function(){pick(r.getAttribute('data-plan'))})});
})();
